module.exports = __webpack_public_path__ + "static/school_support_img1M@2x-d4b9098b14bf5bd560a3d3ac10779164.jpg";